// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "MakeMyShows",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/makemyshows?utm_source=qr&igsh=dXA0MzR5ZnV1ZWgx",
    },
    {
      icon: <FacebookIcon />,
      link: "",
    },
    {
      icon: <TwitterIcon />,
      link: "",
    },
    {
      icon: <YouTubeIcon />,
      link: "",
    },
  ],
  menus: [
    {
      name: "quick links",
      items: [
        { name: "about us", route: "/about-us" },
        { name: "contact us", route: "/contact-us" },
        { name: "our client", href: "" },
        { name: "blogs", href: "" },
        { name: "tems & condition", route: "/terms-and-conditions" },
        { name: "privacy", route: "/privacy-policy" },
        { name: "refund policy", route: "/refund-policy" },
      ],
    },
    {
      name: "",
      items: [
        { name: "Artist In Noida", href: "" },
        { name: "Artist In Delhi", href: "" },
        { name: "Artist In Gurugram", href: "" },
        { name: "Artist In Manali", href: "" },
        { name: "Artist In Chandigarh", href: "" },
        { name: "Artist In Mumbai", href: "" },
        { name: "Artist In Jaipur", href: "" },
        { name: "Artist In Ahmedabad", href: "" },
        { name: "Artist In Bangalore", href: "" },
        { name: "Artist In Pune", href: "" },
        { name: "Artist In Hyderabad", href: "" },
        { name: "Artist In Goa", href: "" },
        
      ],
    },
    {
      name: "entertaiment",
      items: [
        { name: "singer", href: "" },
        { name: "dj", href: "" },
        { name: "Music Bands", href: "" },
        { name: "Musicians", href: "" },
        { name: "Anchor / Emcee", href: "" },
        { name: "Dance Group", href: "" },
        { name: "Celebrities", href: "" },
        { name: "Comedian", href: "" },
      ],
    },
    {
      name: "Events",
      items: [
        { name: "Private Events", href: "" },
        { name: "Wedding", href: "" },
        { name: "House Party", href: "" },
        { name: "Corporate Events", href: "" },
        { name: "Café & Lounges", href: "" },
        { name: "Social events", href: "" },
        { name: "Hotel & Villas", href: "" },
        { name: "Virtual Events", href: "" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
       Copyright &copy; {date} All rights reserved by{" "}
      <MKTypography
        component="a"
        href="/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        MakeMyShows
      </MKTypography>
      .
    </MKTypography>
  ),
};
